module.exports = "#manageReservationformWrapper{width:100%;min-height:100vh;height:100%}\n"